(() => {
  if (window.clarityBookingLoaded) return;
  window.clarityBookingLoaded = true;
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-clarity-booking]');
    if (!form) return;
    if (event.target.matches('[name="properties[Session format]"]')) {
      const onsite = form.querySelector('[value="On-site"]').checked;
      form.querySelector('.sc-onsite').hidden = !onsite;
      const confirmation = form.querySelector('[data-sc-onsite-confirm]');
      confirmation.required = onsite;
      confirmation.disabled = !onsite;
      if (!onsite) confirmation.checked = false;
    }
    if (event.target.matches('[data-sc-variant]')) {
      form.querySelector('[name="id"]').value = event.target.value;
      form.closest('.sc-booking-card').querySelector('.sc-price').textContent = event.target.selectedOptions[0].dataset.price;
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-clarity-booking]');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity() || form.dataset.busy) return;
    form.dataset.busy = 'true';
    const button = form.querySelector('button[type="submit"]');
    const label = form.querySelector('[data-sc-button-label]');
    const original = label.textContent;
    const error = form.querySelector('[data-sc-error]');
    button.disabled = true; label.textContent = 'جارٍ تجهيز حجزك…'; error.hidden = true;
    const root = form.dataset.root.replace(/\/?$/, '/');
    const request = async (path, body) => {
      const response = await fetch(root + path, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'تعذّر تجهيز الحجز. يرجى المحاولة مجدداً.');
      return data;
    };
    try {
      const purchase = async () => {
        const properties = {};
        for (const [key,value] of new FormData(form)) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value) properties[match[1]] = value;
        }
        if (properties['Session format'] !== 'On-site') delete properties['On-site arrangements confirmed'];
        // Direct purchase contains exactly the selected session, never an old basket.
        await request('cart/clear.js', {});
        await request('cart/add.js', {items:[{id:form.querySelector('[name="id"]').value,quantity:1,properties}]});
      };
      if (navigator.locks) await navigator.locks.request('recorded-course-cart', purchase); else await purchase();
      window.location.assign('/en/checkout');
    } catch (failure) {
      error.textContent = failure.message; error.hidden = false;
      button.disabled = false; label.textContent = original; delete form.dataset.busy;
    }
  });
})();
